export default __webpack_public_path__ + "static/media/190.e489bca8.png";